import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Subject} from "rxjs";
import {SearchState, SearchStateService} from "../_core/services/search-state.service";
import {
  ActionPasser,
  BahamutHelper,
  Checkbox,
  Dropdown,
  ErrorMessages,
  GMList,
  Grandmaster,
  Logger,
  Validator
} from "lo-bahamut";
import {SearchService} from "../_core/services/search.service";
import {LoadingSpinnerService} from "../_core/services/loading-spinner.service";
import {HandlebarsService} from "../_core/services/handlebars.service";
import {CareFindrTenantConfigurationService} from "../_core/apiV2/services/care-findr-tenant-configuration.service";
import {ProviderSearchService} from "../_core/apiV2/services/provider-search.service";
import {Router} from "@angular/router";
import {CURRENT_TENNANT} from "../app.component";
import {SearchResultService} from "../services/search-result.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-search-results-v2',
  templateUrl: './search-results-v2.component.html',
  styleUrls: ['./search-results-v2.component.scss']
})
export class SearchResultsV2Component implements  OnInit{
  private url: string = "../../assets/search-result-page.hbs";
  private _data: any;
  isPlanDropDownEnabled = true;
  destroyed$ = new Subject<void>();

  searchState: SearchState = {
    Query: {
      sortBy: 'distance-asc',
    },
    Extra: {},
  };

  printState: SearchState = {
    Query: {},
    Extra: {},
  };

  private searchResultData!: Subscription;

  // elements UK variables
  languageDropdownUK: any;
  genderDropdownUK: any;
  anpCheckboxUK: any;
  handicapCheckboxUK: any;
  pcpCheckboxUK: any;
  languagePillUK: any;
  genderPillUK: any;
  anpPillUk: any;
  handicapPillUK: any;
  pcpPillUk: any;



  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;

  constructor(private searchService: SearchService,
              public actionPasser: ActionPasser,
              public gmList: GMList,
              private loadingSpinnerService: LoadingSpinnerService,
              public logger: Logger,
              private lobhelper: BahamutHelper,
              public errorMessages: ErrorMessages,
              public grandmaster: Grandmaster,
              public validator: Validator,
              private hbs: HandlebarsService,
              private searchStateService: SearchStateService,
              private tenantConfigService: CareFindrTenantConfigurationService,
              private providerSearchService: ProviderSearchService,
              private router: Router,
              private searchResultService: SearchResultService
  ) {
  }

  ngOnInit() {
    this.loadingSpinnerService.showLoader();
    this.getCareLoaDrJson()
    const tenantComponentJs$ = this.tenantConfigService.getTenantComponentBluePrint({
      page_name: 'patient-search',
      tenant: CURRENT_TENNANT
    });

    this.actionPasser.groupEmitter$.subscribe((group: any) => {
      // console.log(group)
      if (group !== undefined && Object.keys(group).length !== 0) {
        switch (group[0].groupName) {
          //search-required groups
          case "updateDistanceDropdown":
            this.updateDistanceDropdown(group);
            break;
          case "updateDistanceSlider":
            this.updateDistanceSlider(group);
            break;

          //search-filter groups
          case "selectedLanguage":
            this.selectedLanguage(group);
            break;
          case "selectedGender":
            this.selectedGender(group);
            break;
          case "checkedAccepting":
            this.checkedAccepting(group);
            break;
          case "checkedHandicap":
            this.checkedHandicap(group);
            break;
          case "checkedPCP":
            this.checkedPCP(group);
            break;
          case "resetFilterLanguage":
            this.resetFilterLanguage(group);
            break;
          case "resetFilterGender":
            this.resetFilterGender(group);
            break;
          case "resetANPCheckbox":
            this.resetANPCheckbox(group);
            break;
          case "resetHandicapCheckbox":
            this.resetHandicapCheckbox(group);
            break;
          case "resetPCPCheckbox":
            this.resetPCPCheckbox(group);
            break;
          case "clearFilters":
            this.clearFilters(group);
            break;
          case "show-more-details":
            this.toggleDetailsWithAnimation(group[1]);
            break;

        }
      }
    });
  }
  toggleDetailsWithAnimation(groupItem: any) {
    const targetId = groupItem?.id;
    if (!targetId) return;

    const contentDiv = document.getElementById(targetId);
    if (!contentDiv) return;

    const isExpanded = contentDiv.classList.contains('expanded');

    if (isExpanded) {
      contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px';
      requestAnimationFrame(() => {
        contentDiv.style.maxHeight = '0px';
        contentDiv.classList.remove('expanded');
      });
    } else {
      contentDiv.classList.add('expanded');
      contentDiv.style.maxHeight = '0px';
      requestAnimationFrame(() => {
        contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px';
      });

      setTimeout(() => {
        contentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }
  ngOnDestroy(): void {
    this.searchResultData.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  addToGrandmaster(viewRef: any, data: any) {
    console.log(data)
    this.grandmaster.addChildrenToThisView(viewRef, data);
    // this.firstLoad = false;
    // setTimeout(() =>{console.log("4")
    //   console.log(this.gmList.gmList)
    //   console.log(this.gmList.gmList[2])}, 0)
  }

  getCareLoaDrJson() {
    this.searchResultData = this.searchResultService.getSearchResultJson(this.url).subscribe(response => {
      this._data = JSON.parse(response).componentsConfig;
    });
    this.loadingSpinnerService.hideLoader();
  }

  //search-required groups
  updateDistanceDropdown(group: any){
    let sliderRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let distanceDDRef = this.gmList.gmList[group[1].uniqueKey].reference;

    if (sliderRef.data !== distanceDDRef.data) {
      if (distanceDDRef.componentRef.componentType === Dropdown) {
        distanceDDRef.checkboxes.forEach((cb: Checkbox) => cb.checked = false);
        distanceDDRef.data = [sliderRef.data];
      } else {
        distanceDDRef.data = sliderRef.data;
      }
    }
  }
  updateDistanceSlider(group: any){
    let distanceDDRef = this.gmList.gmList[group[0].uniqueKey].reference;
    let sliderRef = this.gmList.gmList[group[1].uniqueKey].reference;
    sliderRef.data = distanceDDRef.data[0];
  }

  //search-filter groups
  selectedLanguage(group: any){
    this.languageDropdownUK = group[0].uniqueKey;
    this.languagePillUK = group[1].uniqueKey;
    let languagePillRef = this.gmList.gmList[this.languagePillUK].reference;
    let languageDropdownRef = this.gmList.gmList[this.languageDropdownUK].reference;
    let languageDropdownData = languageDropdownRef.data;
    // if(languageDropdownRef.selected.length != 0){
    // 	languagePillRef.data = languageDropdownRef.selected;
    // 	languagePillRef.hide = false;
    // }else{
    // 	languagePillRef.hide = true;
    // }
    let  areSame = this.lobhelper.compareArrays(languagePillRef.data, languageDropdownData);

    if (!areSame) {
      if(languageDropdownRef.selected.length != 0){
        languagePillRef.data =  languageDropdownData;
        languagePillRef.hide = false;
      }else{
        languagePillRef.hide = true;
      }
      // languagePillRef.data = languageDropdownData;
    }
  }
  selectedGender(group: any){
    this.genderDropdownUK = group[0].uniqueKey;
    let genderDropdownRef = this.gmList.gmList[this.genderDropdownUK].reference;
    this.genderPillUK = group[1].uniqueKey;
    let genderPillRef = this.gmList.gmList[this.genderPillUK].reference;
    if(genderDropdownRef.selected.length != 0){
      genderPillRef.label = genderDropdownRef.selected[0];
      genderPillRef.hide = false;
    }else{
      genderPillRef.hide = true;
    }

  }
  checkedAccepting(group: any){
    this.anpCheckboxUK = group[0].uniqueKey;
    let anpCheckboxRef = this.gmList.gmList[this.anpCheckboxUK].reference;
    this.anpPillUk = group[1].uniqueKey;
    let anpPillRef = this.gmList.gmList[this.anpPillUk].reference;
    if(anpCheckboxRef.checked){
      anpPillRef.label = anpCheckboxRef.label;
      anpPillRef.hide = false;
    }else{
      anpPillRef.hide = true;
    }
  }

  checkedHandicap(group: any){
    this.handicapCheckboxUK = group[0].uniqueKey;
    let handicapCheckboxRef = this.gmList.gmList[this.handicapCheckboxUK].reference;
    this.handicapPillUK = group[1].uniqueKey;
    let handicapPillRef = this.gmList.gmList[this.handicapPillUK].reference;
    if(handicapCheckboxRef.checked){
      handicapPillRef.label = handicapCheckboxRef.label;
      handicapPillRef.hide = false;
    }else{
      handicapPillRef.hide = true;
    }
  }

  checkedPCP(group: any){
    this.pcpCheckboxUK = group[0].uniqueKey;
    let pcpCheckboxRef = this.gmList.gmList[this.pcpCheckboxUK].reference;
    this.pcpPillUk = group[1].uniqueKey;
    let pcpPillRef = this.gmList.gmList[this.pcpPillUk].reference;
    if(pcpCheckboxRef.checked){
      pcpPillRef.label = pcpCheckboxRef.label;
      pcpPillRef.hide = false;
    }else{
      pcpPillRef.hide = true;
    }
  }

  resetFilterLanguage(group: any){
    let languageDropdownRef = this.gmList.gmList[this.languageDropdownUK].reference;
    let pillsGroupsRef = this.gmList.gmList[this.languagePillUK].reference;
    let languagePillGroupData = pillsGroupsRef.data;

    let areSame = this.lobhelper.compareArrays(languageDropdownRef.data, languagePillGroupData);

    if (!areSame) {
      languageDropdownRef.data = languagePillGroupData;
    }
  }
  resetFilterGender(group: any){
    let genderDropdownRef = this.gmList.gmList[this.genderDropdownUK].reference;
    genderDropdownRef.data = [];
  }
  resetANPCheckbox(group: any){
    let handicapCheckboxRef = this.gmList.gmList[this.anpCheckboxUK].reference;
    handicapCheckboxRef.checked = false;
  }

  resetHandicapCheckbox(group: any){
    let anpCheckboxRef = this.gmList.gmList[this.handicapCheckboxUK].reference;
    anpCheckboxRef.checked = false;
  }
  resetPCPCheckbox(group: any){
    let pcpCheckboxRef = this.gmList.gmList[this.pcpCheckboxUK].reference;
    pcpCheckboxRef.checked = false;
  }
  clearFilters(group: any){
    let filterLanguageRef = this.gmList.gmList[group[1].uniqueKey].reference;
    filterLanguageRef.data = [];
    let filterGenderRef = this.gmList.gmList[group[2].uniqueKey].reference;
    filterGenderRef.data = [];
    let filterANPRef = this.gmList.gmList[group[3].uniqueKey].reference;
    filterANPRef.checked = false;
    let filterHandicapRef =  this.gmList.gmList[group[4].uniqueKey].reference;
    filterHandicapRef.checked = false;
    let filterPCPRef = this.gmList.gmList[group[5].uniqueKey].reference;
    filterPCPRef.checked = false;
  }

}
